<app-list-load-error [error]="loadingError" (retry)="refreshView(false)" />

@if (!dateRangeCalendarEventsListStore.isLoading() && (!items || items.length === 0) && !loadingError) {
  @if (notFoundTemplate) {
    <ng-template [ngTemplateOutlet]="notFoundTemplate" />
  } @else {
    <app-no-content-stub imageSrc="assets/placeholders/placeholder-schedule.svg">
      <div class="flex max-w-full flex-col items-center gap-2">
        @if (inTrash) {
          <p class="text-base font-medium text-gray-900 text-center">{{ narrowed ? NO_MATCH_TITLE : TRASH_EMPTY_TITLE }}</p>
        } @else if (inArchive) {
          <p class="text-base font-medium text-gray-900 text-center">{{ narrowed ? NO_MATCH_TITLE : ARCHIVE_EMPTY_TITLE }}</p>
        } @else if (anyEventsFiltered) {
          <p class="text-base font-medium text-gray-900 text-center">No regular events</p>
        } @else {
          <p class="text-base font-medium text-gray-900 text-center">Nothing scheduled</p>
          <p class="text-sm text-gray-600 text-center">New events will appear here</p>
        }
      </div>
    </app-no-content-stub>
  }
}

<div
  #scrollableContainer
  class="overflow-y-auto grow basis-0 has-[app-list-items-separator]:scroll-pt-16"
  appSelectableList
  #appSelectableList="appSelectableList"
  [deselectOnReclick]="false"
  [appSelectableListReset]="resetSelected"
  [appSelectableListItems]="items"
  [deselectOnReclick]="false"
  [appSelectableListChain]="selectionChain()"
  (openSelected)="handleOpenSelected($event)">

  @if (dateRangeCalendarEventsListStore.isLoading() && (!items || items.length === 0)) {
    <app-loading-indicator [inPanel]="true">Loading events...</app-loading-indicator>
  }

  @for (item of items; track item.key; let index = $index) {
    @if (item.showSectionHeader) {
      <!-- SBUX-829: sections here are already projected into the display frame (see convertToItems),
           so the label must read them in the runtime zone rather than project them again. -->
      <app-list-items-separator [value]="item.section" [timeZone]="sectionFrameTimeZone" />
    }

    <app-row-status-mark [row]="item.data" />
    <app-event
      [item]="item.data"
      class="block"
      [class.bg-background-highlight]="item.section === STICKY_ITEM_SECTION"
      [position]="index"
      [withTags]="withTags"
      [withKnots]="withKnots"
      [withBar]="true"
      [short]="false"
      [debug]="debug"
      (appDblClick)="handleDoubleClickItem(item.data)"
      [appSelectable]="item.data"
      [appSelectablePosition]="index"
      [appSelectableIdentifier]="item.data.id"
      [appSelectableListRef]="appSelectableList"
    />
  }
</div>

<app-calendar-pagination
  [calendarType]="dateRangeCalendarEventsListStore.calendarType()"
  [date]="dateRangeCalendarEventsListStore.selectedDate()"
  [loading]="dateRangeCalendarEventsListStore.isLoading()"
  (dateChange)="handlePrevNextTimeSlotPagination($event)"
  (refresh)="refreshView()"
  class="border-t border-border"
/>
